<template>
  <div class="horse-rent-home">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "HorseRentHome",
  
  metaInfo() {
    return {
      title: this.$t("HORSE_RENT.horse_rent_orders"),
    };
  },
};
</script>